import { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';

export function WorkspaceExportButton({
  onExport,
  disabled,
  label = 'Export',
}: {
  onExport: () => void | Promise<void>;
  disabled?: boolean;
  label?: string;
}) {
  const [pending, setPending] = useState(false);

  return (
    <button
      type="button"
      disabled={disabled || pending}
      onClick={() => {
        const result = onExport();
        if (result && typeof (result as Promise<void>).then === 'function') {
          setPending(true);
          void (result as Promise<void>)
            .catch(() => undefined)
            .finally(() => setPending(false));
        }
      }}
      className="text-sm px-3 py-1.5 border border-border rounded-lg hover:bg-surface-muted font-medium inline-flex items-center gap-1.5 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {pending ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Download className="w-3.5 h-3.5" />}
      {label}
    </button>
  );
}
